export default __webpack_public_path__ + "static/media/web.c5b65416.svg";